export default __webpack_public_path__ + "images/0xed3fb761414da74b74f33e5c5a1f78104b188dfc.png";